import { convertCamelToCapitalStart, convertSnakeToCamel } from '@/common/utils/core';
import { MAX_WIDGET_NAME_LENGTH } from '../constants/define';

/**
 * 차트 타입과 displayStyle로 위젯 컴포넌트 이름 생성
 * @param chartType - 차트 타입
 * @param displayStyle - 디스플레이 스타일
 */
export const getWidgetCompName = (chartType: string, displayStyle: string): string => {
  const chartTypeCapital = convertCamelToCapitalStart(convertSnakeToCamel(chartType));
  const displayStyleCapital = convertCamelToCapitalStart(convertSnakeToCamel(displayStyle));
  return `${chartTypeCapital}${displayStyleCapital}Widget`;
};

/**
 * 위젯 이름을 최대 길이로 자르기
 * @param titleText - 제목 텍스트
 */
export const sliceWidgetName = (titleText: string) => {
  return titleText.slice(0, MAX_WIDGET_NAME_LENGTH);
};
